import {
    WorkflowUpdateStepRequest,
    WorkflowWorkflowType,
} from '@calm/evexia-web-sdk';
import createWorkflowApi from '@rhg/libs/api/create-workflow-api';
import useAuth from '@rhg/libs/auth0/use-auth';
import { invalidateQueryKey, useMutation } from '@rhg/libs/react-query';
import { useActiveCircle } from '../use-active-circle';
import {
    workflowByDefnIdForRecipientQueryOptions,
    workflowByTypeForRecipientQueryOptions,
} from '../use-workflows';

export interface UpdateWorkflowStepParameters {
    workflowDefnId?: string;
    workflowType?: WorkflowWorkflowType;
    stepDefnId?: string;
    request: WorkflowUpdateStepRequest;
}
export function useUpdateWorkflowStep() {
    const { getAccessTokenSilently } = useAuth();
    const { activeCircle } = useActiveCircle();
    const { mutate, mutateAsync, ...otherProps } = useMutation({
        mutationFn: async ({
            workflowDefnId = '',
            stepDefnId = '',
            request,
        }: UpdateWorkflowStepParameters) => {
            const api = createWorkflowApi(getAccessTokenSilently);
            const response = await api.v1UpdateStep({
                circleAuthorizationToken: activeCircle!.authorizationJWT!,
                recipientId: activeCircle!.recipient.id,
                workflowDefnId,
                stepDefnId,
                workflowUpdateStepRequest: request,
            });
            return response;
        },
        onSuccess: async (_, { workflowDefnId = '', workflowType }) => {
            // TODO(EVE-10506): callers currently log failures to Datadog only; needs user-facing error UX
            await Promise.all([
                invalidateQueryKey(
                    workflowByTypeForRecipientQueryOptions.queryKey({
                        workflowType,
                        recipientId: activeCircle!.recipient.id,
                    })
                ),
                invalidateQueryKey(
                    workflowByDefnIdForRecipientQueryOptions.queryKey({
                        workflowDefnId,
                        recipientId: activeCircle!.recipient.id,
                    })
                ),
            ]);
        },
    });
    return {
        updateWorkflowStep: mutate,
        updateWorkflowStepAsync: mutateAsync,
        ...otherProps,
    };
}
